module.exports = "/dist/7e367be02cd17a96d513ab74846bafb3.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-400.woff2
// module id = 153
// module chunks = 0